<template>
  <div>
    <edit-menu :menu-items="editMenuItems" :datasetactions="datasetActions" />
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <h2 v-if="pageTitle" class="my-0">{{ pageTitle }}</h2>
        </div>
      </div>
    </div>
    <grid-page
      ref="grid"
      v-bind:config="config"
      v-bind:multi-select="showMultiSelect"
      v-bind:control-name="controlName"
      v-bind:hide-filter-button="true"
      v-bind:context-menu-items="contextMenuItems"
      v-bind:data-source="dataSource">
    </grid-page>
    <batch-result-modal-view ref="batchResultView" />
    <modal-comp
      v-if="modalOpen"
      :show-modal="true"
      ref="modal"
      :closeCallback="modalCloseCallback"
      :before-close="beforeClose"
      :show-save-dialog="hasMutations"
      :custom-class="'modal-lg container pt-5'"
      :show-close-button="false">
      <modal-card :title="modalTitle" @close="modalManualClose" :show-footer="hasMutations">
        <template slot="body">
          <form-container
            v-if="form"
            ref="formcontainer"
            :model-state="modelState"
            :config="form"
            :error-message="formError"
            :orientation="'horizontal'"
            @form-change="onFormChange">
            <slot :item="item" :model-state="modelState" :translation-model-state="translationModelState">

            </slot>
          </form-container>
        </template>

        <template slot="footer">
          <loading-button
            @click="save(true)"
            :title="$t('save')"
            :is-busy="isBusy"
            v-if="hasMutations" />
        </template>
      </modal-card>
    </modal-comp>

    <import-modal v-if="showImport" ref="importModal" :show-modal="true" :closeCallback="importCloseCallback" >
      <start-import :fetchDestination="fetchDestination" v-if="showImportStart"  @importCreated="openImportDetail" />
      <import-detail v-if="importId" :importId="importId" @close="importManualClose" @completed="refreshData"/>
    </import-modal>
  </div>
</template>

<script>
import BatchFactory from 'libs/batchfactory.js';
import BatchResultModalView from 'components/BatchResultModalView.vue';
import GridPage from 'components/Grid/GridPage.vue';
import { ContextMenuItem } from 'libs/classes/grid.js';
import { EditMenuItem } from 'components/NavBar.vue';
import ModalComponent from '@/pages/app/MI/components/Modal.vue';
import formmixin from '@/forms/components.js';
import ModalCard from './ModalCard.vue';
import ImportMixin from '@/mixins/import.js';

export default {
  mixins: [formmixin, ImportMixin],
  props: {
    controller: {
      required: true
    },
    controlName: {
      required: true
    },
    form: {},
    hasMutations: {
      default: false
    },
    authorizeCreate: {
      default: () => []
    },
    authorizeUpdate: {
      default: () => []
    },
    authorizeDelete: {
      default: () => []
    },
    pageTitle: {
      default: ''
    },
    dataSource: {
      default: () => []
    },
    hideCreate: {
      default: false
    },
    hideDelete: {
      default: false
    },
    forSelectedRowItems: {
      default: () => []
    },
    fetchDestination: {}
  },
  components: {
    'grid-page': GridPage,
    'batch-result-modal-view': BatchResultModalView,
    'modal-comp': ModalComponent,
    'modal-card': ModalCard
  },
  data () {
    const self = this;
    return {
      config: {
        webController: this.controller.resourcecontroller,
        onListItemClicked: function (item) { self.openDetail(item); },
        controlName: this.controlName
      },
      searchExpressions: {},
      contextMenuItems: [],
      editMenuItems: [],
      selectedRows: [],
      datasetActions: [],
      allowCreate: false,
      allowEdit: false,
      allowDelete: false,
      modalOpen: false,
      modelState: null,
      translationModelState: null,
      formError: '',
      item: null,
      isBusy: false
    };
  },
  async created() {
  },
  async mounted () {
    const self = this;
    let all = [...this.authorizeCreate, ...this.authorizeUpdate, ...this.authorizeDelete];
    await this.$authorize(all);

    this.allowCreate = await this.$authorize(this.authorizeCreate);
    this.allowEdit = await this.$authorize(this.authorizeUpdate);
    this.allowDelete = await this.$authorize(this.authorizeDelete);

    if (this.allowCreate && !this.hideCreate) {
      this.editMenuItems.push(new EditMenuItem(this.$t('editmenu.add'), this.openNew, 'editmenu-create'));
    }
    this.loadContextMenu();
  },
  methods: {
    grid() {
      return this.$refs.grid;
    },
    onFormChange () {
      this.updateHasMutations(true);
    },
    modalCloseCallback () {
      this.modalOpen = false;
    },
    async beforeClose () {
      if (this.hasMutations) {
        return await this.save();
      }
      this.item = null;
      return true;
    },
    async save (close = false) {
      const loader = this.$dialogs.loader();
      this.modelState = null;
      this.translationModelState = null;
      this.formError = null;
      this.isBusy = true;
      let success = false;
      try {
        let data = {
          ...this.item,
          ...this.form.getFormData()
        };
        await this.controller.Save(data);
        success = true;

      } catch (error) {
        if (error.ModelState) {
          this.modelState = error.ModelState;
        }
        if (error.Error) {
          this.formError = error.Error;
        }
        if (error.TranslationModelState && error.TranslationModelState.ModelState){
          this.translationModelState = error.TranslationModelState.ModelState;
        }

      } finally {
        loader();
        this.isBusy = false;
        if (success) {
          this.refreshData();
          this.updateHasMutations(false);

          // in nexttick to make sure hasMutations is updated on modal
          if (close) this.$nextTick(() => this.modalManualClose());
        }
      }
      return success;
    },
    updateHasMutations (value) {
      this.$emit('update:hasMutations', value);
    },
    loadContextMenu () {
      var self = this;
      if ((this.allowDelete && !this.hideDelete) || (this.forSelectedRowItems !== null && this.forSelectedRowItems.length > 0))  {
        let forSelectedItems = [];
        this.contextMenuItems = [];
        
        if (this.forSelectedRowItems !== null && this.forSelectedRowItems !== undefined && this.forSelectedRowItems.length > 0) {
          for (let index = 0; index < this.forSelectedRowItems.length; index++) {
            forSelectedItems.push(this.forSelectedRowItems[index]);
          }
        } 

        if (this.allowDelete && !this.hideDelete) {
          forSelectedItems.push(ContextMenuItem.Delete(self.deleteItems));
        }

        if (forSelectedItems.length > 0) {
          this.contextMenuItems.push(ContextMenuItem.CreateForSelectedRow(forSelectedItems));
        }
      }
    },
    async openNew () {
      if (!this.authorizeCreate) return;

      this.modelState = null;
      this.translationModelState = null;
      this.formError = null;
      this.updateHasMutations(false);
      this.item = await this.controller.GetNew();
      this.form.loadData(this.item);
      this.modalOpen = true;
      this.$emit('open-detail');
    },
    async openDetail (item) {
      if (!this.authorizeUpdate) return;

      try {
        this.modelState = null;
        this.translationModelState = null;
        this.formError = null;
        this.updateHasMutations(false);
        this.item = await this.controller.GetItem(item.AutoID);
        this.form.loadData(this.item);
        this.modalOpen = true;
        this.$emit('open-detail');
      } catch (error) {
        if (error.Error) {
          this.formError = error.Error;
        }
        if (error.ModelState) {
          this.modelState = error.ModelState;
        }
      }
    },
    refreshData () {
      this.$refs.grid.refreshCurrentDataSet();
    },
    deleteItems (items) {
      let mapped = items.map(x => {
        return {
          data: {
            AutoID: x.AutoID
          },
          description: '<strong>' + x.ID + '</strong>' + (x.Descr === null || x.Descr === undefined ? '' : ' - ' + '<strong>' + x.Descr + '</strong>')
        };
      });
      let onResult = BatchFactory.BatchComplete(this.$refs.batchResultView, () => { this.$toaster.showSuccess(this.$t('batch_action_succeeded')); }, () => this.refreshData());
      let cMethod = async (item) => {
        return this.controller.Delete(item.AutoID);
      };
      BatchFactory.BatchStart(this.$refs.batchResultView, mapped, this.$t('delete'), cMethod, onResult, true, this.$t('confirm_message_delete', {count: mapped.length}));
    },
    modalManualClose () {
      this.$refs.modal.manualClose();
    }
  },
  computed: {
    formItems () {
      return this.form.config;
    },
    modalTitle () {
      if (!this.item) return '';
      if (this.item.AutoID === 0)
        return this.$t('generic.add');
      else
        return this.$t('generic.edit');
    },
    showMultiSelect () {
      return this.contextMenuItems !== undefined && this.contextMenuItems !== null && this.contextMenuItems.length > 0;
    }    
  }
};
</script>

